import Vue from 'vue'
import App from './App.vue'
// 引入路由对象
import router from './router.js'
// 引入axios对象
import axios from 'axios'
import VueAxios from 'vue-axios'
// 引入公共样式文件
import './assets/css/base.css'
// 引入ElementUI
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import './theme/element/theme/index.css'
//引入复制到剪贴板
import VueClipboard from 'vue-clipboard2'
//引入工具类文件
import utils from './utils/common-utlis.js'
import request from './utils/request-utils.js'
import publicMethods from './utils/public-methods.js'
import currency from './utils/currency-utils.js'
import { getParam } from './utils/api-utils/api-params.js'
import { getCustomerInfo } from './utils/api-utils/api-customer.js'
import i18n, { LOCALE_STORAGE_KEY, setLocale } from './i18n'

// 非父子组件之间传值及事件广播监听中转
import eventBus from './utils/event-bus.js'
import moment from 'moment'
import {
	constant,
	allUserSettingKeyList
} from './config.js'

let isFirsrLoad = true

Vue.prototype.$moment = moment;
Vue.prototype.$utils = utils;
Vue.prototype.$request = request;
Vue.prototype.$public = publicMethods;
Vue.prototype.$eventBus = eventBus;
Vue.prototype.$currency = currency;

Vue.use(VueAxios, axios);
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
});
Vue.use(VueClipboard);

// 提示开关
Vue.config.productionTip = false
Vue.config.devtools = true //生产环境也可使用vue-devtools工具

// Vue 实例配置（提取为变量，避免 Object.assign({}, x) 这种对象展开）
const vueAppOption = {
	router: router, // 使用路由对象
	i18n,
	render: h => h(App),
};

// 启动引导：jkymini 前置流程必须在 new Vue 之前完成
// 原因：
//  1. getJmallApiVersion 走老链路（不需要 token），把 jmall_api_version 写入 localStorage，
//     供 visitFakeLogin 计算正确的 businessTypeCode（TOC_LOGIN_JMALL / TOC_LOGIN_JMALL_SINGLE）
//  2. visitFakeLogin 用正确的 businessTypeCode 拿到与 origin_name 匹配的 access_token
//  3. visitFakeLogin 的 callback 写 localStorage.pc_accessToken_toCLogin，
//     子组件 created 发起的 jkymini 请求才能带上新 token（不再抢跑用旧 token）
// 仅在 jkymini 开关打开且不在登录态时才执行（已登录用户用真用户 token，不阻塞）
function bootstrap() {
	// 必须在所有 jkymini/老链路请求之前先解析 URL 里的吉客号，
	// 否则 getJmallApiVersion() 里的 sys.getsetting 拿到的 target_member_name 是空
	// （getUserName 之前是在 router.beforeEach 第一次触发时才调用，时序太晚）
	const memberNameFromUrl = request.getUserName();
	if (!memberNameFromUrl && !request.pcUseJkymini) {
		// 老链路 + 没有吉客号：交给 router.beforeEach 走 error 页
	}

	if (!request.pcUseJkymini || localStorage.getItem("pc_customerId")) {
		// 老链路或已登录：直接 new Vue
		// 已登录用户启动登录态 token 刷新定时器（基于 pc_lastLoginDistributorId 维持登录态）
		if (localStorage.getItem("pc_customerId")) {
			request.startUserTokenRefreshTimer();
		}
		return new Vue(vueAppOption).$mount('#app');
	}

	// 1. 先获取商城版本（jkymini 前置，必须在 visitFakeLogin 之前）
	request.getJmallApiVersion().then(apiVersion => {
		// 灰度切换：接口返回 jmall-single 但当前在 jmc 域名，需要跳转到 single 服务
		if (location.href.includes("/jmc/pcmall") && apiVersion === "jmall-single") {
			const newHref = location.href.replace('/jmc/', '/jmall_pc_single/');
			console.log('[灰度切换] 跳转到 single：', newHref);
			location.replace(newHref);
			return;
		}

		// 2. 再游客态登录（此时 pc_jmall_api_version 已写入 localStorage）
		request.visitFakeLogin().then(() => {
			console.log('[启动引导] 游客态 token 已就位，new Vue');
		}).catch(err => {
			console.warn('[游客态登录] 启动失败，jkymini 网关可能走不通：', err);
		}).finally(() => {
			// 无论成功失败都继续 new Vue，不阻塞主流程
			new Vue(vueAppOption).$mount('#app');
		});
	}).catch(err => {
		// getJmallApiVersion 失败：兜底继续 new Vue（老链路可能通）
		console.warn('[获取商城版本] 失败，兜底继续：', err);
		new Vue(vueAppOption).$mount('#app');
	});
}

//全局路由前置守卫，判断链接中是否有吉客号
router.beforeEach(async (to, from, next) => {
	if (parent != window) {
		try {
			window.parent.postMessage({
				cmd: 'changeUrl',
				params: {
					success: true,
					data: to.fullPath
				}
			}, '*');
		} catch {}
	}
	let userName = request.getUserName();
	if (!userName && to.name != 'error') {
		console.log("吉客号获取失败");
		next({
			name: 'error'
		});
	}

	// 商城准入检测
	if (to.name != 'login' && to.name != 'error' && !await checkInLimitJudge()) {
		return next({
			name: 'login',
			NAVTYPE: 'replace' // redirectTo
		});
	}

	// 需要在进入页面之前获取的配置
	await getParamBeforeLoad();

	// 页面跳转
	next();

	// 根据版本号 判断是否需要刷新
	let newPcmallVersion = await utils.getSysSetting("pcmall_version");
	location.href.includes("/jmc/pcmall") && (!localStorage.getItem("pcmall_version") || newPcmallVersion != localStorage.getItem("pcmall_version")) && window.location.reload();
})

async function getParamBeforeLoad() {
	// 可以做到在进入页面前加载完配置
	let paramList = await getParam('isOpenLoginLimit,loginLimitType,isOpenShowVisitorPrice,decimalKeepPlaces,restricted_explainText,isOpenZeroStockBuy,pcmall_logo,isShowGoodsLongWidthHeight,isShowGoodsWeight,isShowGoodsVolume,pcmall_title,isShowGoodsDetailWithLimit,pcmall_defaultLanguage');

	// 优先使用本地语言缓存 无则使用后台设置
	if (!localStorage.getItem(LOCALE_STORAGE_KEY)) {
		setLocale(paramList.pcmall_defaultLanguage);
	}

	// 游客展示价 （开启 限制登录允许查看价格 相当于 关闭游客展示价）
	localStorage.setItem('isOpenShowVisitorPrice', !(paramList.isOpenLoginLimit == '1' && paramList.loginLimitType == 'auditLimitOfPrice') && paramList.isOpenShowVisitorPrice != '0' ? '1' : '0');

	// 小数保留位数
	localStorage.setItem('decimalKeepPlaces', paramList.decimalKeepPlaces || 2);

	// 区域限购提示
	localStorage.setItem('restricted_explainText', paramList.restricted_explainText || '');

	// 负库存下单
	localStorage.setItem('isOpenZeroStockBuy', paramList.isOpenZeroStockBuy);
	
	// 是否可见商品主图和详情
	localStorage.setItem('isShowGoodsDetailWithLimit', paramList.isOpenLoginLimit == '1' && paramList.loginLimitType == 'auditLimitOfPrice' && paramList.isShowGoodsDetailWithLimit == '0' ? '0' : '1');
	
	if (isFirsrLoad) {
		// 浏览器页签图标
		setFavicon(paramList)
	}
	isFirsrLoad = false;
}

/**
 * 浏览器页签图标
 */
function setFavicon(paramList) {
	document.getElementById('favicon').href = !!paramList.pcmall_logo && !paramList.pcmall_logo.includes('model_ads') ? paramList.pcmall_logo : 'https://web.jackyun.com//login/img/favicon.ico'
	// 域名转发时 传递favicon
	!!paramList.pcmall_logo && window.parent.postMessage({ type: 'favicon', url: paramList.pcmall_logo , mallName: paramList.pcmall_title || 'JMALL商城'}, '*')
}

/**
 * 商城准入校验
 */
async function checkInLimitJudge() {
	// 获取配置 以及 客户信息
	let paramList = await getParam('isOpenLoginLimit,loginLimitType,loginForMemberGradeId,loginForCustomerTagStrategy,loginForCustomerTagNames');
	let loginLimitType = paramList.loginLimitType;
	let isOpenLoginLimit = paramList.isOpenLoginLimit == '1';
	let loginForMemberGradeId = paramList.loginForMemberGradeId;
	let loginForCustomerTagStrategy = paramList.loginForCustomerTagStrategy;
	let loginForCustomerTagNames = paramList.loginForCustomerTagNames;

	let customerInfo = await getCustomerInfo();
	let isAlreadyHadCustomerInfo = !!customerInfo && !!customerInfo.phone;

	// 黑名单用户 不允许进入商城
	if ((customerInfo.error || "").includes("黑名单")) {
		return false;
	}

	// 没开启限制登录设置允许进入商城
	if (!isOpenLoginLimit || ['auditLimitOfPrice', 'auditLimitOfPersonalInfo'].includes(loginLimitType)) {
		return true;
	}

	// 没有客户档案信息
	if (!isAlreadyHadCustomerInfo) {
		return false;
	}

	// 检测处理异常会员等级情况，空数据影响判断结果
	let memberGradeId = customerInfo.vipLevel == '0' || !customerInfo.vipLevel ? '*****' : customerInfo.vipLevel;
	if (loginLimitType == 'memberGradeLimit' && isAlreadyHadCustomerInfo && !!loginForMemberGradeId && loginForMemberGradeId != "all" && (loginForMemberGradeId.indexOf(memberGradeId) < 0)) {
		return false;
	}

	// 检测客户标签限制
	if (loginLimitType == 'memberGradeLimit' && loginForCustomerTagStrategy) {
		// tagArr 是标签名字符串数组
		let customerTagNames = customerInfo.tagArr || [];
		// 'all' 视为空字符串，不限制
		let allowTagNames = (loginForCustomerTagNames && loginForCustomerTagNames !== 'all') ? loginForCustomerTagNames.split(',').filter(v => v) : [];

		// 包含策略：客户标签必须在允许列表中（空表示不限）
		if (loginForCustomerTagStrategy === "包含") {
			if (allowTagNames.length > 0) {
				// 客户没有任何标签时也应判定为不符合（不满足"包含"条件）
				let hasValidTag = customerTagNames.some(tagName => allowTagNames.includes(tagName));
				if (!hasValidTag) {
					return false;
				}
			}
		}
		// 排除策略：客户标签不能在排除列表中
		else if (loginForCustomerTagStrategy === "排除") {
			let excludeTagNames = allowTagNames;
			if (excludeTagNames.length > 0) {
				let hasExcludedTag = customerTagNames.some(tagName => excludeTagNames.includes(tagName));
				if (hasExcludedTag) {
					return false;
				}
			}
		}
	}

	return true;
}

// 启动引导
bootstrap();